import { cva, type VariantProps } from 'class-variance-authority';

export { default as Badge } from './Badge.vue';

export const badgeVariants = cva(
  'inline-flex items-center rounded-full border border-slate-200 px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-slate-950 focus:ring-offset-2 whitespace-nowrap overflow-hidden text-ellipsis max-w-full',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-brand-blue text-slate-50 hover:bg-slate-900/80',
        secondary: 'border-transparent bg-brand-yellow text-slate-900 hover:bg-yellow-300/80',
        success: 'border-transparent bg-emerald-600 text-slate-50 hover:bg-emerald-700/80',
        destructive: 'border-transparent bg-red-500 text-slate-50 hover:bg-red-500/80',
        warning: 'border-transparent bg-brand-orange text-slate-50 hover:bg-brand-orange/80',
        purple: 'border-transparent bg-brand-purple text-slate-50 hover:bg-brand-purple/80',
        outline: 'text-slate-950',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export type BadgeVariants = VariantProps<typeof badgeVariants>;
